import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrTooltip from '@components/BrTooltip';
import BrText from '@components/BrText';
import './brMultistateToggle.scss';

export default class BrMultistateToggle extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    states: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        tooltip: PropTypes.any,
      }),
    ).isRequired,
    selectedValue: PropTypes.any,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { className, states, selectedValue, onClick } = this.props;
    const classname = cn('br-multistate-toggle', className);

    return (
      <div className={classname}>
        {states.map((state) => (
          <BrTooltip className="toggle-tooltip-holder" key={state.title}>
            <div
              key={state.title}
              // eslint-disable-next-line eqeqeq
              className={`multistate-toggle-label ${selectedValue == state.value && 'selected'}`}
              onClick={() => onClick(state.value)}
            >
              <BrText>{state.title}</BrText>
            </div>
            {state.tooltip && <BrTooltip.Tooltip>{state.tooltip}</BrTooltip.Tooltip>}
          </BrTooltip>
        ))}
      </div>
    );
  }
}
